import React, { useState } from 'react'

import { Box, Button, Grid, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Users as UsersIcon, HelpCircle as HelpCircleIcon } from 'react-feather'

import { ContentHeader, LoadingFeedback, Page } from 'components'
import {
  InformationCard,
  QuestionnairesBoard,
  TutorialDialog,
  UsersManagementDialog,
} from './components'

import useAuthSupplier from 'hooks/useAuthSupplier'
import constants from 'constants/index'

const Home = () => {
  const [openUsersDialog, setOpenUsersDialog] = useState(false)
  const [openTutorialDialog, setOpenTutorialDialog] = useState(false)

  const { loaded, companySupplier } = useAuthSupplier()

  const isCompleted =
    companySupplier?.progressStatus ===
    constants.companySuppliers.COMPLETED_PROGRESS_STATUS

  const handleOpenUsersDialog = () => setOpenUsersDialog(true)
  const handleCloseUsersDialog = () => setOpenUsersDialog(false)

  const handleOpenTutorialDialog = () => setOpenTutorialDialog(true)
  const handleCloseTutorialDialog = () => setOpenTutorialDialog(false)

  return (
    <Page title="Portal de Fornecedores">
      <LoadingFeedback open={!loaded} />
      <Box px={2}>
        <ContentHeader
          title="Avaliação de Fornecedor"
          historyBreadcumbs={false}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<UsersIcon size={20} />}
            onClick={handleOpenUsersDialog}
            fullWidth
          >
            Usuários
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTutorialDialog}
            fullWidth
          >
            Tutorial
          </Button>
        </ContentHeader>
        {isCompleted && (
          <Box mb={2}>
            <Alert severity="success">
              <Typography variant="body1">
                Avaliação finalizada! Suas respostas foram enviadas com sucesso.
                Se precisar alterar alguma resposta, entre em contato com a
                empresa que solicitou a avaliação.
              </Typography>
            </Alert>
          </Box>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InformationCard />
          </Grid>
          <Grid item xs={12}>
            <QuestionnairesBoard />
          </Grid>
        </Grid>
      </Box>
      {openUsersDialog && (
        <UsersManagementDialog
          open={openUsersDialog}
          setOpen={setOpenUsersDialog}
          onClose={handleCloseUsersDialog}
        />
      )}
      {openTutorialDialog && (
        <TutorialDialog
          open={openTutorialDialog}
          setOpen={setOpenTutorialDialog}
          onClose={handleCloseTutorialDialog}
        />
      )}
    </Page>
  )
}

export default Home
